import { AppBar, Box, Tab, Tabs, Typography } from '@material-ui/core'
import { useState } from 'react'
import { useRoleHierarchyManager } from './queries/roleHierarchyManagement'
import { RoleHierarchyChanger } from './roleHierarchyChanger'
import { RoleHierarchyCreator } from './roleHierarchyCreator'
import { UserCreator } from './userCreator'

export function AdminScreen(): JSX.Element {
  const {
    getRoleHierarchiesQuery: { data: roleHierarchies, isLoading, error },
  } = useRoleHierarchyManager()
  const [selectedTab, setSelectedTab] = useState<number>(0)

  if (!!error) return <Typography>Error: {error}</Typography>
  if (isLoading) return <Typography>Loading...</Typography>
  if (!roleHierarchies)
    return <Typography>No role role hierarchies exist</Typography>

  return (
    <div>
      <AppBar position='static'>
        <Tabs value={selectedTab} onChange={(e, n) => setSelectedTab(n)}>
          <Tab label='Change Role Hierarchy' />
          <Tab label='Create User' />
          <Tab label='Create Role Hierarchy' />
        </Tabs>
      </AppBar>
      <Box marginTop={1} marginLeft={5} marginRight={5}>
        {
          [
            <RoleHierarchyChanger roleHierarchies={roleHierarchies} />,
            <UserCreator roleHierarchies={roleHierarchies} />,
            <RoleHierarchyCreator roleHierarchies={roleHierarchies} />,
          ][selectedTab]
        }
      </Box>
    </div>
  )
}
